import { ActionIcon, Box, CSSObject } from "@mantine/core";
import { SetStateAction } from "jotai";
import { RESET } from "jotai/utils";
import { pxToRem } from "theme";

import Flex from "components/Flex";
import { DeleteIcon } from "components/Icons/Delete";
import { UnUploadedImage } from "components/PhotoUpload/types";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

import { GridImage } from "../PhotoGrid/types";
import { useStyles } from "./styles";

export type PhotoGridProps = {
  images: GridImage[];
  deleteFromAtom?: (update: typeof RESET | SetStateAction<UnUploadedImage[]>) => Promise<void>;
  gridGap?: string | number;
  sxImageContainer?: any;
  imageFit?: CSSObject["objectFit"];
};

export const PhotoGridDocuments = ({
  images,
  deleteFromAtom,
  gridGap = pxToRem[12],
  sxImageContainer = {},
}: PhotoGridProps) => {
  const { t } = useClientTranslation();
  const { classes } = useStyles({ gridGap });

  return (
    <Box className={`${classes.photoGridDocuments} ${images.length === 1 && classes.singlePhotoGrid}`}>
      {images.map(({ id, src, alt, caption }: GridImage) => (
        <Flex key={id}>
          <Flex sx={sxImageContainer} className={classes.documentContainer}>
            {deleteFromAtom && id && (
              <ActionIcon
                aria-label="Delete image"
                onClick={() => deleteFromAtom((photos) => photos?.filter((photo) => id !== photo.id))}
                className={classes.deleteImageIcon}
              >
                <DeleteIcon />
              </ActionIcon>
            )}
            <img src={src} alt={alt} className={classes.document} />
          </Flex>
          {caption && (
            <Text sizeVariant="md" className={classes.caption}>
              {t(caption)}
            </Text>
          )}
        </Flex>
      ))}
    </Box>
  );
};
